<template src="./IOTLanding.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
//import { saveExcel } from "@progress/kendo-vue-excel-export";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("iotExposer");
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
// import vendorService from "@/api/vendorService";
// const apiMethods = require("./../../../../api/api")
import DialogBox from "@/components/DialogBox";

import ViewDropdown from "@/components/ViewDropdown";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";

import EmployeeErrors from "@/components/EmployeeError";

export default {
    components: {
        DialogBox,
        ViewDropdown,
        EmployeeErrors,

    },
    data: function () {
        return {
            title: null,
            temp: { address: "sfwnrfwjnfjwf fwefnwjenfwefnwenf fwenf" },
            gridHeight: window.innerHeight - 120,
            // addoredit: false,
            gridData: [],
            searchText: "",
            skip: 0,
            take: 25,
            pageSize: 25,
            pageable: {
                previousNext: true,
                pageSizes: [5, 10, 25, 100, 500],
                pageSize: 10,
            },
            add: true,
            sort: [{ field: "name", dir: "asc" }],
            filteredColumns: [],
            columns: [
                { hidden: false, field: "apiKey", title: "Api Key", width: '150px', checked: true, defaultSelected: true, },
                { hidden: false, field: "name", title: "Name", width: '150px', checked: true, defaultSelected: true, },
                { hidden: false, field: "code", title: "Code", width: '150px', checked: true, defaultSelected: true, },
                { hidden: false, field: "tenantId", title: "Tenant ID", width: '150px', checked: true, cell: this.tenants, defaultSelected: true, },
                { hidden: false, field: "url", title: "URL", width: '150px', checked: true, defaultSelected: true, },
                { hidden: false, field: "serviceType", title: "Service Type", width: '150px', checked: true, defaultSelected: true, },

                { hidden: false, field: "url", title: "Sync URL", width: '150px', cell: this.getSyncUrl, checked: true, defaultSelected: false, },
                { hidden: false, field: "methodType", title: "Method Type", width: '150px', cell: this.getMethodType, checked: true, defaultSelected: false, },

                { hidden: false, field: "header", title: "Header Key", width: '200px', cell: this.getHeaderKey, checked: true, defaultSelected: false, },
                { hidden: false, field: "parameter", title: "Param Key", width: '200px', cell: this.getParamKey, checked: true, defaultSelected: false, },

                { hidden: false, field: "deviceid", title: "Device Type", width: '150px', cell: this.getdeviceId, checked: true, defaultSelected: true, },
                { hidden: false, field: "name", title: "Name", width: '200px', cell: this.getName, checked: true, defaultSelected: true, },
                { hidden: false, field: "drivername", title: "Driver Name", width: '200px', cell: this.getDriverName, checked: true, defaultSelected: true, },
                { hidden: false, field: "drivertel", title: "Driver Phone.NO", width: '150px', cell: this.getDriverTel, checked: true, defaultSelected: false, },
                { hidden: false, field: "ignchk", title: "Ignchk", width: '150px', cell: this.getIgnchk, checked: true, defaultSelected: false, },
                { hidden: false, field: "odo", title: "Odo", width: '150px', cell: this.getOdo, checked: true, defaultSelected: false, },
                { hidden: false, field: "lastseen", title: "Last Seen", width: '150px', cell: this.getLastSeen, checked: true, defaultSelected: false, },
                { hidden: false, field: "lat", title: "Latitude", width: '150px', cell: this.getLat, checked: true, defaultSelected: false, },
                { hidden: false, field: "lon", title: "Longitude", width: '150px', cell: this.getLon, checked: true, defaultSelected: false, },
                { hidden: false, field: "ign", title: "Ign", width: '150px', cell: this.getIgn, checked: true, defaultSelected: false, },
                { hidden: false, field: "immobilizeStatus", title: "Immobilize Status", width: '150px', cell: this.getImmobilizeStatus, checked: true, defaultSelected: false, },

                { hidden: false, field: "syncMode", title: "Sync Mode", width: '150px', cell: this.getSyncMode, checked: true, defaultSelected: false, },
                { hidden: false, field: "syncType", title: "Sync Type", width: '150px', cell: this.getSyncType, checked: true, defaultSelected: false, },
                { hidden: false, field: "syncInterval", title: "Sync Interval", width: '150px', cell: this.getSyncInterval, checked: true, defaultSelected: false, },
                { hidden: false, field: "bulkDataLimit", title: "Bulk Data Limit", width: '150px', cell: this.getBulkDataLimit, checked: true, defaultSelected: false, },

                { hidden: false, cell: CommandCell, width: '150px', locked: true, title: "Actions", ignoreCheckbox: true, },
            ],
            dataItems: [],
            visibleDialog: false,
            isDeletedDataItem: {},
            iotInfo: {}

        };
    },
    methods: {
        // device: function (h, tdElement, props) {
        //     const field = props.field;
        //     var value = props.dataItem[field];
        //     if (!value) {
        //         return h("td", {}, "");
        //     }
        //     const device = this.initialData.deviceTypes.find((t) => t.id === value);
        //     return h("td", {}, device ? device.name : '');
        // },

        tenants: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem[field];
            if (!value) {
                return h("td", {}, "");
            }
            if (this.initialData.tenants) {
                const tenant = this.initialData.tenants.find((t) => t.id === value);
                return h("td", {}, tenant ? tenant.name : '');
            }
        },
        getSyncUrl: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation[field];
            if (!value) {
                return h("td", {}, "");
            }
            return h("td", {}, value ? value : '');
        },

        getMethodType: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation[field];
            if (!value) {
                return h("td", {}, "");
            }
            return h("td", {}, value ? value : '');
        },

        getSyncMode: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncConfig[field];
            if (!value) {
                return h("td", {}, "");
            }
            return h("td", {}, value ? value : '');
        },

        getSyncType: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncConfig[field];
            if (!value) {
                return h("td", {}, "");
            }
            return h("td", {}, value ? value : '');
        },

        getSyncInterval: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncConfig[field];
            if (!value) {
                return h("td", {}, "");
            }
            return h("td", {}, value ? value : '');
        },

        getBulkDataLimit: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncConfig[field];
            if (!value) {
                return h("td", {}, "");
            }
            return h("td", {}, value ? value : '');
        },
        getHeaderKey: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation[field];
            if (!value) {
                return h("td", {}, "");
            }
            var headerKeyValue = JSON.stringify(value);
            return h("td", {}, headerKeyValue ? headerKeyValue : '');
        },

        getParamKey: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation[field];
            if (!value) {
                return h("td", {}, "");
            }
            var paramKeyValue = JSON.stringify(value);
            return h("td", {}, paramKeyValue ? paramKeyValue : '');
        },
        getdeviceId: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },
        getName: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');

        },
        getDriverName: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getDriverTel: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getIgnchk: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getOdo: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getLastSeen: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getLat: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getLon: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getIgn: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },

        getImmobilizeStatus: function (h, tdElement, props) {
            const field = props.field;
            var value = props.dataItem.configuration.syncLocation.body;
            var getValues = value.find((el) => el.fieldName == field)
            if (!getValues) {
                return h("td", {}, "");
            }
            return h("td", {}, getValues ? getValues.fieldValue : '');
        },
        sortChangeHandler: function (e) {
            this.sort = e.sort;
        },
        showErrors: function () {
            this.$refs.rosterErros.show();
        },

        pageChangeHandler: function (event) {
            this.skip = event.page.skip;
            this.take = event.page.take;
        },
        showAdd: function () {
            this.add = true;
        },

        goIOTToAddPage: function () {
            this.$router.push({ name: "iotAddUpdate", params: { add: true } });
        },

        remove: function (item) {
            this.$refs.form.openWindow();
            this.isDeletedDataItem = item;
        },

        OkMethod() {
            let item = this.isDeletedDataItem.dataItem;
            return this.$store
                .dispatch("iotExposer/deleteIOTDevice", item)
                .then(() => {
                    notify(MESSAGES.DELETE_SUCCESS);
                })
                .catch(notifyApiError);
        },

        edit: function (item) {
            return this.$store.dispatch("iotExposer/editDevice", item.dataItem.id);
        },

        columnChange: function (e) {
            if (e.item.checked) {
                e.item.hidden = false;
            } else {
                e.item.hidden = true;
            }
            localStorage.setItem(
                LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT,
                JSON.stringify(this.filteredColumns)
            );
        },

        getDataOnload() {
            this.$store.dispatch("iotExposer/getIOTServices", this.payload);
            this.$store.dispatch("iotExposer/getInitialData", this.initialData)
        },
    },

    computed: {
        ...mapState(['loader', "EmployeeErrors", "initialData", "resultset", "devices"]),
        // ...mapGetters(["getDevices", "getSensors", "getTenants"]),
        total() {
            return this.resultset ? this.resultset.length : 0;
        },

        // **commented to hide records from displaying
        items: {
            get: function () {
                return orderBy(
                    this.deviceListVal.slice(this.skip, this.take + this.skip),
                    this.sort
                );
            },
        },

        deviceListVal() {
            this.resultset.map(device => {
                if (device.deviceTypeId && this.initialData.deviceTypes) {
                    device.deviceType = this.initialData.deviceTypes.find((t) => t.id === device.deviceTypeId);
                }
            })
            return this.resultset.filter((data) => JSON.stringify(data).toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
        },
    },

    created: function () {
        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type == "setSeclectedFacility") {
                this.getDataOnload();

            }
        });
    },
    beforeDestroy() {
        this.unsubscribe();
    },
    mounted() {
        this.getDataOnload();
    },
    beforeMount() {
        const eListColumns = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT)
        );
        if (!eListColumns) {
            this.filteredColumns = this.columns;
        } else {
            let items = [];
            this.columns.map((col, i) => {
                const obj = eListColumns.find(c => c.field === col.field);
                // Ignoring last column
                if (i < this.columns.length - 1)
                    if (obj) {
                        items.push({
                            ...col,
                            hidden: obj.hidden,
                            checked: obj.checked,
                        });
                    } else {
                        items.push({ ...col });
                    }
            });
            // adding ignored last column
            items.push(this.columns[this.columns.length - 1]);
            this.filteredColumns = items;
        }
    }
};
</script>

<style lang="scss" scoped>
.search_mobile {
    width: 15% !important;
    border-radius: 5px;
}

@media only screen and (max-width: 768px) {
    .search_mobile {
        width: 40% !important;
    }

    .mobile_hide_show {
        display: none;
    }

    .driver_header_mobile {
        flex-direction: row !important;
        padding: 10px 10px 10px 10px;
    }

    .page-header .title-text {
        font-size: 12px;
    }
}
</style>

<style>
.k-grid tr {
    height: 40px;
}
</style>
